import { useCallback } from 'react';
import { DEMO_MESSAGE, openWhatsApp } from '../lib/contact';

/**
 * Returns a stable click handler that opens WhatsApp with the given (or default
 * demo) message. Use for every "Richiedi Demo" / WhatsApp CTA across the app.
 */
export const useWhatsAppDemo = (message: string = DEMO_MESSAGE) =>
  useCallback(() => openWhatsApp(message), [message]);
